exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upsell-slider[data-v-531c0ef8] {\n  margin-top: 15px;\n}\n.upsell-slider header[data-v-531c0ef8] {\n    padding: 0 20px;\n}\n", ""]);

// exports
